import Button from '../../Button'
import { Container } from '../Container'

import { BUTTON_ICON_SIZES, BUTTON_SIZES } from './Buttons.constants'

import * as styles from './Buttons.module.css'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function Outlined() {
  return (
    <>
      <Container label='Button, outlined, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, disabled, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            disabled
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isLoading
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, with pre icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, with pre icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, with post icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, with post icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            disabled
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, circle icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            disabled
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, circle icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            isCircle
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
